import { isNumber } from 'lodash';
import { Countries } from '@lendi/core-constants';
import { Item } from '@lendi-ui/dropdown';

export enum ENTITY_TYPE {
  APPLICATION = 'APPLICATION',
  APPLICANT = 'APPLICANT',
  ASSET = 'ASSET',
  COMPANY = 'COMPANY',
  COMPANY_DECLARATION = 'COMPANY_DECLARATION',
  LIABILITY = 'LIABILITY',
  ACCOUNTANT = 'ACCOUNTANT',
  SOLICITOR = 'SOLICITOR',
  COMPLIANCE = 'COMPLIANCE',
  GUARANTOR_COMPLIANCE = 'GUARANTOR_COMPLIANCE',
  LICENSED_BUILDER = 'LICENSED_BUILDER',
  ASSET_ACCOUNT = 'ASSET_ACCOUNT',
  LIABILITY_ACCOUNT = 'LIABILITY_ACCOUNT',
  TRUST = 'TRUST',
  TRUST_SETTLOR = 'TRUST_SETTLOR',
  TRUST_BENEFICIARY = 'TRUST_BENEFICIARY',
  PREFERRED_REPAYMENT = 'PREFERRED_REPAYMENT',
}

export enum APPLICANT_QUESTIONS {
  CITY_OF_BIRTH = 'CITY_OF_BIRTH',
  COUNTRY_OF_BIRTH = 'COUNTRY_OF_BIRTH',
  COUNTRY_OF_CITIZENSHIP = 'COUNTRY_OF_CITIZENSHIP',
  MOTHERS_MAIDEN_NAME = 'MOTHERS_MAIDEN_NAME',
  POST_SETTLEMENT_MAILING_ADDRESS = 'POST_SETTLEMENT_MAILING_ADDRESS',
  SPOUSE_FIRST_NAME = 'SPOUSE_FIRST_NAME',
  SPOUSE_LAST_NAME = 'SPOUSE_LAST_NAME',
  SPOUSE_TITLE = 'SPOUSE_TITLE',
  SUBSTANTIAL_BENEFITS = 'SUBSTANTIAL_BENEFITS',
}

export enum ASSET_QUESTIONS {
  CONTACT_COMPANY_NAME = 'CONTACT_COMPANY_NAME',
  CONTACT_FIRST_NAME = 'CONTACT_FIRST_NAME',
  CONTACT_LAST_NAME = 'CONTACT_LAST_NAME',
  CONTACT_PHONE = 'CONTACT_PHONE',
  CONTACT_TITLE = 'CONTACT_TITLE',
  CONTACT_TYPE = 'CONTACT_TYPE',
  DATE_OF_PURCHASE = 'DATE_OF_PURCHASE',
}

export enum COMPANY_QUESTIONS {
  CURRENT_LENDER = 'CURRENT_LENDER',
  LEGAL_ENTITIES_IN_GROUP = 'LEGAL_ENTITIES_IN_GROUP',
  LEGAL_ENTITIES_WITH_CURRENT_LENDER = 'LEGAL_ENTITIES_WITH_CURRENT_LENDER',
  MONTHS_WITH_CURRENT_LENDER = 'MONTHS_WITH_CURRENT_LENDER',
  YEARS_OF_TRADING = 'YEARS_OF_TRADING',
  BRANCH = 'BRANCH',
  BUSINESS_DIVERSIFIED = 'BUSINESS_DIVERSIFIED',
  PASSIVE_ENTITY = 'PASSIVE_ENTITY',
  COMMERCIAL_RELATIONSHIP = 'COMMERCIAL_RELATIONSHIP',
  BUSINESS_WITH_ONE_CUSTOMER_MORE_THAN_25_PERCENT = 'BUSINESS_WITH_ONE_CUSTOMER_MORE_THAN_25_PERCENT',
  OUTSTANDING_TAX = 'OUTSTANDING_TAX',
  PRINCIPAL_PLACE_OF_BUSINESS_LEASED = 'PRINCIPAL_PLACE_OF_BUSINESS_LEASED',
  TERM_LOAN_FUNDING_100_PERCENT = 'TERM_LOAN_FUNDING_100_PERCENT',
  ACTING_AS_FRANCHISE = 'ACTING_AS_FRANCHISE',
  WORKING_IN_IMPORT_EXPORT = 'WORKING_IN_IMPORT_EXPORT',
  INVESTING_IN_PROPERTY = 'INVESTING_IN_PROPERTY',
}

export enum TRUST_QUESTIONS {
  PASSIVE_ENTITY = 'PASSIVE_ENTITY',
}

export enum COMPANY_DECLARATION_QUESTIONS {
  HAS_PAST_OR_CURRENT_DEBTS = 'HAS_PAST_OR_CURRENT_DEBTS', // Liberty
  IS_US_CITIZEN_OR_RESIDENT = 'IS_US_CITIZEN_OR_RESIDENT', // NAB
  HAD_REPAYMENT_DIFFICULTY_OR_LEGAL_PROCEEDINGS = 'HAD_REPAYMENT_DIFFICULTY_OR_LEGAL_PROCEEDINGS', // NAB
  HAD_LATE_PAYMENTS_OR_ARREARS_OR_ADVERSE_CREDIT_HISTORY = 'HAD_LATE_PAYMENTS_OR_ARREARS_OR_ADVERSE_CREDIT_HISTORY', // Pepper
  HAS_GOOD_CONDUCT = 'HAS_GOOD_CONDUCT', // Macquarie
  WAS_BANKRUPT_OR_INSOLVENT = 'WAS_BANKRUPT_OR_INSOLVENT', // Liberty
}

export enum COMPLIANCE_QUESTIONS {
  AGREEMENT_OF_UNDERSTANDING = 'AGREEMENT_OF_UNDERSTANDING',
  CUSTOMER_DISCUSSION_SUMMARY = 'CUSTOMER_DISCUSSION_SUMMARY',
  INTERVIEWED_IN_PERSON = 'INTERVIEWED_IN_PERSON',
  INTERVIEW_LOCATION = 'INTERVIEW_LOCATION',
  REQUIREMENTS_AND_OBJECTIVES_SUMMARY = 'REQUIREMENTS_AND_OBJECTIVES_SUMMARY',
  UNDERSTAND_ENGLISH = 'UNDERSTAND_ENGLISH',
}

export enum GUARANTOR_COMPLIANCE_QUESTIONS {
  BROKER_DECLARATION = 'BROKER_DECLARATION',
  CONFIRM_COULD_MEET_LOAN_REPAYMENTS = 'CONFIRM_COULD_MEET_LOAN_REPAYMENTS',
  CONFIRM_WOULD_SELL_FAMILY_HOME = 'CONFIRM_WOULD_SELL_FAMILY_HOME',
  DOCUMENTATION_DELIVERY_METHOD = 'DOCUMENTATION_DELIVERY_METHOD',
  INDEPENDENT_ADVICE_TYPE_REQUIRED = 'INDEPENDENT_ADVICE_TYPE_REQUIRED',
  INTERVIEW_DATE = 'INTERVIEW_DATE',
  INTERVIEW_LOCATION = 'INTERVIEW_LOCATION',
  INTERVIEWED_IN_PERSON = 'INTERVIEWED_IN_PERSON',
  IS_ONLY_PERSON_PRESENT = 'IS_ONLY_PERSON_PRESENT',
  IS_UNDER_POWER_OF_ATTORNEY = 'IS_UNDER_POWER_OF_ATTORNEY',
  LENDER_SPECIFIC_BROKER_DECLARATION = 'LENDER_SPECIFIC_BROKER_DECLARATION',
  UNDERSTANDS_ENGLISH = 'UNDERSTANDS_ENGLISH',
  UNDERSTANDS_GUARANTEE_SIGNING_PERIOD = 'UNDERSTANDS_GUARANTEE_SIGNING_PERIOD',
  UNDERSTANDS_SECURITY_GUARANTEE = 'UNDERSTANDS_SECURITY_GUARANTEE',
}

export enum RELATED_PARTY_QUESTIONS {
  ADDRESS = 'ADDRESS',
  BUSINESS_NAME = 'BUSINESS_NAME',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  PHONE = 'PHONE',
  TITLE = 'TITLE',
  EMAIL = 'EMAIL',
}

export enum LICENSED_BUILDER_QUESTIONS {
  ADDRESS = 'ADDRESS',
  BUSINESS_NAME = 'BUSINESS_NAME',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  PHONE = 'PHONE',
  TITLE = 'TITLE',
  LICENSED_BUILDER_LANDLINE = 'LICENSED_BUILDER_LANDLINE',
  LICENSE_NUMBER = 'LICENSE_NUMBER',
}

export enum ACCOUNT_BSB_QUESTIONS {
  ACCOUNT_BSB = 'ACCOUNT_BSB',
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
}

export enum LIABILITY_QUESTIONS {
  ANNUAL_INTEREST_RATE = 'ANNUAL_INTEREST_RATE',
}

export enum APPLICATION_QUESTIONS {
  RATE_LOCK = 'RATE_LOCK',
  FAST_REFI = 'FAST_REFI',
}

export const COUNTRY_OPTIONS = Object.values(Countries)
  .filter((v) => !isNumber(v))
  .map((country: string | Countries) => ({
    value: country,
    label: country,
  })) as Item[];

export enum TRUST_SETTLOR_QUESTIONS {
  HAS_SETTLOR = 'HAS_SETTLOR',
  REASON = 'REASON',
  SETTLOR_TYPE = 'SETTLOR_TYPE',
  TITLE = 'TITLE',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  CONTACT_NUMBER = 'CONTACT_NUMBER',
  CONTACT_EMAIL = 'CONTACT_EMAIL',
  BENEFICIARIES = 'BENEFICIARIES',
}

export enum TRUST_BENEFICIARY_QUESTIONS {
  DISTRIBUTION_PERCENTAGE = 'DISTRIBUTION_PERCENTAGE',
}

export enum PREFERRED_REPAYMENT_QUESTIONS {
  RepaymentMethod = 'REPAYMENT_METHOD',
  RepaymentFrequency = 'REPAYMENT_FREQUENCY',
  AccountNameIfDirectDebitNewAccount = 'ACCOUNT_NAME_IF_DIRECT_DEBIT_NEW_ACCOUNT',
  AccountNameIfDirectDebitExistingAccount = 'ACCOUNT_NAME_IF_DIRECT_DEBIT_EXISTING_ACCOUNT',
  AccountNumberIfDirectDebitExistingAccount = 'ACCOUNT_NUMBER_IF_DIRECT_DEBIT_EXISTING_ACCOUNT',
  BSBIfDirectDebitExistingAccount = 'BSB_IF_DIRECT_DEBIT_EXISTING_ACCOUNT',
  InstitutionNameIfIfDirectDebitExistingAccount = 'INSTITUTION_NAME_IF_DIRECT_DEBIT_EXISTING_ACCOUNT',
}
